import React from "react";
import { Link } from "gatsby";

const Footer = () => (
  <footer className="flex justify-center bg-indigo-700 w-full h-32 absolute">
    <div className="h-full p-6">
      <ul className="flex justify-around w-48 mb-2">
        <li>
          <Link
            to={`/about`}
            className="block px-3 py-2 rounded-md text-sm font-medium leading-5 text-gray-300 hover:text-white hover:bg-indigo-800 focus:outline-none focus:text-white focus:bg-indigo-800 transition duration-150 ease-in-out"
          >
            About
          </Link>
        </li>
        <li>
          <Link
            to={`/contact`}
            className="block px-3 py-2 rounded-md text-sm font-medium leading-5 text-gray-300 hover:text-white hover:bg-indigo-800 focus:outline-none focus:text-white focus:bg-indigo-800 transition duration-150 ease-in-out"
          >
            Contact
          </Link>
        </li>
        <li>
          <Link
            to={`/privacy-policy`}
            className="block px-3 py-2 rounded-md text-sm font-medium leading-5 text-gray-300 hover:text-white hover:bg-indigo-800 focus:outline-none focus:text-white focus:bg-indigo-800 transition duration-150 ease-in-out"
          >
            Privacy
          </Link>
        </li>
      </ul>

      <div className="w-48 flex justify-center text-white text-sm">
        <span>
          Copyright © {new Date().getFullYear()}
          {` `}
          <Link
            to="/"
            className="text-white focus:outline-none focus:shadow-outline"
          >
            Electr
          </Link>
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
{
  /* <div className="social-section">
          <ul>
            <li>
              <a href={`https://www.facebook.com`}>
                <i className="fab fa-facebook-f fa-2x" />
              </a>
            </li>
            <li>
              <a href={`https://www.facebook.com`}>
                <i className="fab fa-twitter fa-2x" />
              </a>
            </li>
            <li>
              <a href={`https://www.facebook.com`}>
                <i className="fab fa-pinterest fa-2x" />
              </a>
            </li>
          </ul>
        </div> */
}
